import railyApiService from "../raily-api.service";
import BillingsCargoTaxiUpdateRequest from "./cargo-taxi/update/billings-cargo-taxi-update.request";
import BillingsCargoTaxiDetailsRequest from "./cargo-taxi/details/billings-cargo-taxi-details.request";
import billingsCargoTaxiBulkUpdateStatusRequestFactory from "./cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status-request.factory";
import BillingsCargoTaxiBulkUpdateStatusRequest from "./cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status.request";
import BillingsCargoTaxiBulkUpdateStatusResponse from "./cargo-taxi/bulk-update-status/billings-cargo-taxi-bulk-update-status.response";
import billingsOrderAddressesRequestFactory from "./order/addresses/billings-order-addresses-request.factory";
import BillingsOrderAddressesRequest, {
  BillingsOrderAddressesRequestQueryParams,
} from "./order/addresses/billings-order-addresses.request";
import BillingsOrderAddressesResponse from "./order/addresses/billings-order-addresses.response";
import BillingsOrderRelatedTaxiDriverRequest from "./order/related/taxi-driver/billings-order-related-taxi-driver.request";
import BillingsOrderRelatedTaxiDriverResponse from "./order/related/taxi-driver/billings-order-related-taxi-driver.response";
import BillingsOrderRelatedTaxiTaxiRequest from "./order/related/taxi-taxi/billings-order-related-taxi-taxi.request";
import BillingsOrderRelatedTaxiTaxiResponse from "./order/related/taxi-taxi/billings-order-related-taxi-taxi.response";
import BillingsPlanEntryRelatedCargoTaxiRequest from "./plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi.request";
import BillingsPlanEntryRelatedCargoTaxiResponse from "./plan-entry/related/cargo-taxi/billings-plan-entry-related-cargo-taxi.response";
import BillingsPlanEntryRelatedTaxiTaxiRequest from "./plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi.request";
import BillingsPlanEntryRelatedTaxiTaxiResponse from "./plan-entry/related/taxi-taxi/billings-plan-entry-related-taxi-taxi.response";
import BillingsCargoTaxiUpdateResponse from "./cargo-taxi/update/billings-cargo-taxi-update.response";
import BillingsCargoTaxiDetailsResponse from "./cargo-taxi/details/billings-cargo-taxi-details.response";
import billingsCargoTaxiUpdateRequestFactory from "./cargo-taxi/update/billings-cargo-taxi-update-request.factory";
import BillingsOrderCargoTaxiRecalculateRequest from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate.request";
import BillingsOrderCargoTaxiRecalculateResponse from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate.response";
import billingsOrderCargoTaxiRecalculateRequestFactory from "./order/cargo-taxi/recalculate/billings-order-cargo-taxi-recalculate-request.factory";
import BillingsOrderCargoTaxiDraftRequest from "./order/cargo-taxi/draft/billings-order-cargo-taxi-draft.request";
import BillingsOrderCargoTaxiDraftResponse from "./order/cargo-taxi/draft/billings-order-cargo-taxi-draft.response";
import BillingsOrderCargoTaxiCreateRequest from "./order/cargo-taxi/create/billings-order-cargo-taxi-create.request";
import BillingsOrderCargoTaxiCreateResponse from "./order/cargo-taxi/create/billings-order-cargo-taxi-create.response";
import billingsOrderCargoTaxiCreateRequestFactory from "./order/cargo-taxi/create/billings-order-cargo-taxi-create-request.factory";
import BillingsCargoTaxiUpdateStatusRequest from "./cargo-taxi/update-status/billings-cargo-taxi-update-status.request";
import billingsCargoTaxiUpdateStatusRequestFactory from "./cargo-taxi/update-status/billings-cargo-taxi-update-status-request.factory";
import BillingsOrderRailyTaxiDraftRequest from "./order/raily-taxi/draft/billings-order-raily-taxi-draft.request";
import BillingsOrderRailyTaxiDraftResponse from "./order/raily-taxi/draft/billings-order-raily-taxi-draft.response";
import BillingsOrderRailyTaxiRecalculateResponse from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate.response";
import BillingsOrderRailyTaxiRecalculateRequest from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate.request";
import billingsOrderRailyTaxiRecalculateRequestFactory from "./order/raily-taxi/recalculate/billings-order-raily-taxi-recalculate-request.factory";
import BillingsOrderRailyTaxiCreateRequest from "./order/raily-taxi/create/billings-order-raily-taxi-create.request";
import BillingsOrderRailyTaxiCreateResponse from "./order/raily-taxi/create/billings-order-raily-taxi-create.response";
import billingsOrderRailyTaxiCreateRequestFactory from "./order/raily-taxi/create/billings-order-raily-taxi-create-request.factory";
import BillingsOrderRelatedTaxiRailyRequest from "./order/related/taxi-raily/billings-order-related-taxi-raily.request";
import BillingsOrderRelatedTaxiRailyResponse from "./order/related/taxi-raily/billings-order-related-taxi-raily.response";
import BillingsOrderRelatedCargoRailyRequest from "./order/related/cargo-raily/billings-order-related-cargo-raily.request";
import BillingsOrderRelatedCargoRailyResponse from "./order/related/cargo-raily/billings-order-related-cargo-raily.response";
import BillingsOrderCargoRailyAddRequest, {
  BillingsOrderCargoRailyAddRequestBody,
} from "./order/cargo-raily/add/billings-order-cargo-raily-add.request";
import BillingsOrderCargoRailyAddResponse from "./order/cargo-raily/add/billings-order-cargo-raily-add.response";
import billingsOrderCargoRailyAddRequestFactory from "./order/cargo-raily/add/billings-order-cargo-raily-add-request.factory";
import BillingsOrderCargoRailyRecalculateRequest, {
  BillingsOrderCargoRailyRecalculateRequestBody,
} from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate.request";
import BillingsOrderCargoRailyRecalculateResponse from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate.response";
import billingsOrderCargoRailyRecalculateRequestFactory from "./order/cargo-raily/recalculate/billings-order-cargo-raily-recalculate-request.factory";
import BillingsOrderCargoRailyDraftRequest from "./order/cargo-raily/draft/billings-order-cargo-raily-draft.request";
import BillingsOrderCargoRailyDraftResponse from "./order/cargo-raily/draft/billings-order-cargo-raily-draft.response";
import BillingsOrderRelatedRailyTaxiRequest from "./order/related/raily-taxi/billings-order-related-raily-taxi.request";
import BillingsOrderRelatedRailyTaxiResponse from "./order/related/raily-taxi/billings-order-related-raily-taxi.response";
import BillingsOrderForwardBillingsDownloadRequest, {
  BillingsOrderForwardBillingsDownloadQueryParams,
} from "./order-forward-billings/download/billings-order-forward-billings-download.request";
import BillingsOrderForwardBillingsDownloadResponse from "./order-forward-billings/download/billings-order-forward-billings-download.response";
import billingsOrderForwardBillingsDownloadRequestFactory from "./order-forward-billings/download/billings-order-forward-billings-download-request.factory";
import BillingsOrderForwardBillingsListRequest, {
  BillingsOrderForwardBillingsListQueryParams,
} from "./order-forward-billings/list/billings-order-forward-billings-list.request";
import BillingsOrderForwardBillingsListResponse from "./order-forward-billings/list/billings-order-forward-billings-list.response";
import billingsOrderForwardBillingsListRequestFactory from "./order-forward-billings/list/billings-order-forward-billings-list-request.factory";
import BillingsPlanEntryTaxiDriverAddRequest, {
  BillingsPlanEntryTaxiDriverAddRequestBody,
} from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add.request";
import BillingsPlanEntryTaxiDriverAddResponse from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add.response";
import billingsPlanEntryTaxiDriverAddRequestFactory from "./plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add-request.factory";
import BillingsPlanEntryTaxiDriverRecalculateRequest, {
  BillingsPlanEntryTaxiDriverRecalculateRequestBody,
} from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate.request";
import billingsPlanEntryTaxiDriverRecalculateRequestFactory from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate-request.factory";
import BillingsPlanEntryTaxiDriverRecalculateResponse from "./plan-entry/taxi-driver/recalculate/billings-plan-entry-taxi-driver-recalculate.response";
import BillingsPlanEntryTaxiDriverDraftRequest from "./plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft.request";
import BillingsPlanEntryTaxiDriverDraftResponse from "./plan-entry/taxi-driver/draft/billings-plan-entry-taxi-driver-draft.response";
import BillingsTaxiTaxiDetailsRequest from "./taxi-taxi/details/billings-taxi-taxi-details.request";
import BillingsTaxiTaxiDetailsResponse from "./taxi-taxi/details/billings-taxi-taxi-details.response";
import BillingsTaxiTaxiUpdateStatusRequest from "./taxi-taxi/update-status/billings-taxi-taxi-update-status.request";
import BillingsTaxiTaxiUpdateStatusResponse from "./taxi-taxi/update-status/billings-taxi-taxi-update-status.response";
import billingsTaxiTaxiUpdateStatusRequestFactory from "./taxi-taxi/update-status/billings-taxi-taxi-update-status.request.factory";
import BillingsOrderForwardTaxiTaxiAddRequest, {
  BillingsOrderForwardTaxiTaxiAddRequestBody,
} from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add.request";
import BillingsOrderForwardTaxiTaxiAddResponse from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add.response";
import billingsOrderForwardTaxiTaxiAddRequestFactory from "./order-forward/taxi-taxi/add/billings-order-forward-taxi-taxi-add-request.factory";
import BillingsOrderForwardTaxiTaxiDraftRequest from "./order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft.request";
import BillingsOrderForwardTaxiTaxiDraftResponse from "./order-forward/taxi-taxi/draft/billings-order-forward-taxi-taxi-draft.response";
import BillingsOrderForwardRelatedCargoTaxiRequest from "./order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi.request";
import BillingsOrderForwardRelatedCargoTaxiResponse from "./order-forward/related/cargo-taxi/billings-order-forward-related-cargo-taxi.response";
import BillingsOrderForwardRelatedTaxiDriverRequest from "./order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver.request";
import BillingsOrderForwardRelatedTaxiDriverResponse from "./order-forward/related/taxi-driver/billings-order-forward-related-taxi-driver.response";
import BillingsOrderForwardRelatedTaxiTaxiRequest from "./order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi.request";
import BillingsOrderForwardRelatedTaxiTaxiResponse from "./order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi.response";
import BillingsOrderForwardTaxiTaxiRecalculateRequest from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate.request";
import BillingsOrderForwardTaxiTaxiRecalculateResponse from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate.response";
import billingsOrderForwardTaxiTaxiRecalculateRequestFactory from "./order-forward/taxi-taxi/recalculate/billings-order-forward-taxi-taxi-recalculate.request.factory";
import BillingsTaxiTaxiEditRequest from "./taxi-taxi/edit/billings-taxi-taxi-edit.request";
import BillingsTaxiTaxiEditResponse from "./taxi-taxi/edit/billings-taxi-taxi-edit.response";
import billingsTaxiTaxiEditRequestFactory from "./taxi-taxi/edit/billings-taxi-taxi-edit.request.factory";
import BillingsTaxiDriverDetailsRequest from "./taxi-driver/details/billings-taxi-driver-details.request";
import BillingsTaxiDriverDetailsResponse from "./taxi-driver/details/billings-taxi-driver-details.response";
import BillingsTaxiDriverUpdateRequest from "./taxi-driver/update/billings-taxi-driver-update.request";
import BillingsTaxiDriverUpdateResponse from "./taxi-driver/update/billings-taxi-driver-update.response";
import billingsTaxiDriverUpdateRequestFactory from "./taxi-driver/update/billings-taxi-driver-update.request.factory";
import BillingsOrderTaxiRailyAddRequest, {
  BillingsOrderTaxiRailyAddRequestBody,
} from "./order/taxi-raily/add/billings-order-taxi-raily-add.request";
import BillingsOrderTaxiRailyAddResponse from "./order/taxi-raily/add/billings-order-taxi-raily-add.response";
import billingsOrderTaxiRailyAddRequestFactory from "./order/taxi-raily/add/billings-order-taxi-raily-add-request.factory";
import BillingsOrderTaxiRailyRecalculateRequest, {
  BillingsOrderTaxiRailyRecalculateRequestBody,
} from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate.request";
import BillingsOrderTaxiRailyRecalculateResponse from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate.response";
import billingsOrderTaxiRailyRecalculateRequestFactory from "./order/taxi-raily/recalculate/billings-order-taxi-raily-recalculate-request.factory";
import BillingsOrderTaxiRailyDraftRequest from "./order/taxi-raily/draft/billings-order-taxi-raily-draft.request";
import BillingsOrderTaxiRailyDraftResponse from "./order/taxi-raily/draft/billings-order-taxi-raily-draft.response";

const billingsApiService = () => {
  const getOrderForwardRelatedCargoTaxiBillings = async (
    request: BillingsOrderForwardRelatedCargoTaxiRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardRelatedCargoTaxiResponse> => {
    const url = `/billings/orders-forwarding/${request.forwardingId}/related/cargo-taxi`;

    return railyApiService().get<BillingsOrderForwardRelatedCargoTaxiResponse>({
      url,
      abortSignal,
    });
  };

  const getOrderForwardRelatedTaxiDriverBillings = async (
    request: BillingsOrderForwardRelatedTaxiDriverRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardRelatedTaxiDriverResponse> => {
    const url = `/billings/orders-forwarding/${request.forwardingId}/related/taxi-driver`;

    return railyApiService().get<BillingsOrderForwardRelatedTaxiDriverResponse>(
      {
        url,
        abortSignal,
      },
    );
  };

  const getOrderForwardRelatedTaxiTaxiBillings = async (
    request: BillingsOrderForwardRelatedTaxiTaxiRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardRelatedTaxiTaxiResponse> => {
    const url = `/billings/orders-forwarding/${request.forwardingId}/related/taxi-taxi`;

    return railyApiService().get<BillingsOrderForwardRelatedTaxiTaxiResponse>({
      url,
      abortSignal,
    });
  };

  const getPlanEntryRelatedCargoTaxiBillings = async (
    request: BillingsPlanEntryRelatedCargoTaxiRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsPlanEntryRelatedCargoTaxiResponse> => {
    const url = `/billings/plan-entry/${request.planEntryId}/related/cargo-taxi`;

    return railyApiService().get<BillingsPlanEntryRelatedCargoTaxiResponse>({
      url,
      abortSignal,
    });
  };

  const getPlanEntryRelatedTaxiTaxiBillings = async (
    request: BillingsPlanEntryRelatedTaxiTaxiRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsPlanEntryRelatedTaxiTaxiResponse> => {
    const url = `/billings/plan-entry/${request.planEntryId}/related/taxi-taxi`;

    return railyApiService().get<BillingsPlanEntryRelatedTaxiTaxiResponse>({
      url,
      abortSignal,
    });
  };

  const getOrderRelatedTaxiDriverBillings = async (
    request: BillingsOrderRelatedTaxiDriverRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRelatedTaxiDriverResponse> => {
    const url = `/billings/orders/${request.orderId}/related/taxi-driver`;

    return railyApiService().get<BillingsOrderRelatedTaxiDriverResponse>({
      url,
      abortSignal,
    });
  };

  const getOrderRelatedTaxiTaxiBillings = async (
    request: BillingsOrderRelatedTaxiTaxiRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRelatedTaxiTaxiResponse> => {
    const url = `/billings/orders/${request.orderId}/related/taxi-taxi`;

    return railyApiService().get<BillingsOrderRelatedTaxiTaxiResponse>({
      url,
      abortSignal,
    });
  };

  const getOrderBillingsAddresses = async (
    request: BillingsOrderAddressesRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderAddressesResponse> => {
    const url = `/billings/orders/${request.orderId}/addresses`;

    const queryParams: BillingsOrderAddressesRequestQueryParams =
      billingsOrderAddressesRequestFactory.createQueryParams(request);

    return railyApiService().get<BillingsOrderAddressesResponse>({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getCargoTaxiBillingsDetails = (
    request: BillingsCargoTaxiDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsCargoTaxiDetailsResponse> => {
    const url = `/billings/${request.billingUuid}/cargo-taxi`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const updateCargoTaxiBillings = (
    request: BillingsCargoTaxiUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsCargoTaxiUpdateResponse> => {
    const url = `/billings/${request.billingUuid}/cargo-taxi`;

    const body = billingsCargoTaxiUpdateRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const getOrderCargoTaxiBillingsDraft = (
    request: BillingsOrderCargoTaxiDraftRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderCargoTaxiDraftResponse> => {
    const url = `/billings/orders/${request.orderUuid}/cargo-taxi/draft`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const recalculateOrderCargoTaxiBillings = (
    request: BillingsOrderCargoTaxiRecalculateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderCargoTaxiRecalculateResponse> => {
    const url = `/billings/orders/${request.orderUuid}/cargo-taxi/recalculate`;

    const body =
      billingsOrderCargoTaxiRecalculateRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const createOrderCargoTaxiBillings = (
    request: BillingsOrderCargoTaxiCreateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderCargoTaxiCreateResponse> => {
    const url = `/billings/orders/${request.orderUuid}/cargo-taxi`;

    const body = billingsOrderCargoTaxiCreateRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const updateCargoTaxiBillingsStatus = (
    request: BillingsCargoTaxiUpdateStatusRequest,
    abortSignal: AbortSignal,
  ) => {
    const url = `/billings/${request.billingUuid}/cargo-taxi/status`;

    const body =
      billingsCargoTaxiUpdateStatusRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const getOrderRailyTaxiBillingsDraft = (
    request: BillingsOrderRailyTaxiDraftRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRailyTaxiDraftResponse> => {
    const url = `/billings/orders/${request.orderUuid}/raily-taxi/draft`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const recalculateOrderRailyTaxiBillings = (
    request: BillingsOrderRailyTaxiRecalculateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRailyTaxiRecalculateResponse> => {
    const url = `/billings/orders/${request.orderUuid}/raily-taxi/recalculate`;

    const body =
      billingsOrderRailyTaxiRecalculateRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const addOrderCargoRailyBillings = (
    request: BillingsOrderCargoRailyAddRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderCargoRailyAddResponse> => {
    const url = `/billings/orders/${request.orderUuid}/cargo-raily`;

    const body: BillingsOrderCargoRailyAddRequestBody =
      billingsOrderCargoRailyAddRequestFactory.create(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const createOrderRailyTaxiBillings = (
    request: BillingsOrderRailyTaxiCreateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRailyTaxiCreateResponse> => {
    const url = `/billings/orders/${request.orderUuid}/raily-taxi`;

    const body = billingsOrderRailyTaxiCreateRequestFactory.createBody(request);
    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const recalculateOrderCargoRailyBillings = (
    request: BillingsOrderCargoRailyRecalculateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderCargoRailyRecalculateResponse> => {
    const url = `/billings/orders/${request.orderUuid}/cargo-raily/recalculate`;

    const body: BillingsOrderCargoRailyRecalculateRequestBody =
      billingsOrderCargoRailyRecalculateRequestFactory.create(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const updateBulkStatusCargoTaxiBillings = (
    request: BillingsCargoTaxiBulkUpdateStatusRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsCargoTaxiBulkUpdateStatusResponse> => {
    const url = `/billings/cargo-taxi/bulk-status`;

    const body =
      billingsCargoTaxiBulkUpdateStatusRequestFactory.createBody(request);
    const queryParams =
      billingsCargoTaxiBulkUpdateStatusRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().put({
      url,
      abortSignal,
      body,
      queryParams,
    });
  };

  const getOrderRelatedTaxiRailyBillings = (
    request: BillingsOrderRelatedTaxiRailyRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRelatedTaxiRailyResponse> => {
    const url = `/billings/orders/${request.orderUuid}/related/taxi-raily`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getOrderRelatedCargoRailyBillings = (
    request: BillingsOrderRelatedCargoRailyRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRelatedCargoRailyResponse> => {
    const url = `/billings/orders/${request.orderUuid}/related/cargo-raily`;
    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getOrderCargoRailyBillingsDraft = (
    request: BillingsOrderCargoRailyDraftRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderCargoRailyDraftResponse> => {
    const url = `/billings/orders/${request.orderUuid}/cargo-raily/draft`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getOrderRelatedRailyTaxiBillings = (
    request: BillingsOrderRelatedRailyTaxiRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderRelatedRailyTaxiResponse> => {
    const url = `/billings/orders/${request.orderId}/related/raily-taxi`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getOrderForwardBillingsDownload = async (
    request: BillingsOrderForwardBillingsDownloadRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardBillingsDownloadResponse> => {
    const url = `/billings/order-forwarding-billings/csv-dump`;

    const queryParams: BillingsOrderForwardBillingsDownloadQueryParams =
      billingsOrderForwardBillingsDownloadRequestFactory.createQueryParams(
        request,
      );

    return railyApiService().getFile({
      url,
      abortSignal,
      queryParams,
    });
  };

  const getOrderForwardBillingsList = (
    request: BillingsOrderForwardBillingsListRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardBillingsListResponse> => {
    const url = `/billings/order-forwarding-billings`;

    const queryParams: BillingsOrderForwardBillingsListQueryParams =
      billingsOrderForwardBillingsListRequestFactory.createQueryParams(request);
    return railyApiService().get({
      url,
      abortSignal,
      queryParams,
    });
  };

  const addPlanEntryTaxiDriverBillings = (
    request: BillingsPlanEntryTaxiDriverAddRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsPlanEntryTaxiDriverAddResponse> => {
    const url = `/billings/plan-entry/${request.planEntryId}/taxi-driver`;

    const body: BillingsPlanEntryTaxiDriverAddRequestBody =
      billingsPlanEntryTaxiDriverAddRequestFactory.createBody(request);
    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const addOrderForwardTaxiTaxiBillings = (
    request: BillingsOrderForwardTaxiTaxiAddRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardTaxiTaxiAddResponse> => {
    const url = `/billings/orders-forwarding/${request.forwardingId}/taxi-taxi`;

    const body: BillingsOrderForwardTaxiTaxiAddRequestBody =
      billingsOrderForwardTaxiTaxiAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const recalculatePlanEntryTaxiDriverBillings = (
    request: BillingsPlanEntryTaxiDriverRecalculateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsPlanEntryTaxiDriverRecalculateResponse> => {
    const url = `/billings/plan-entry/${request.planEntryId}/taxi-driver/recalculate`;

    const body: BillingsPlanEntryTaxiDriverRecalculateRequestBody =
      billingsPlanEntryTaxiDriverRecalculateRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const getPlanEntryTaxiDriverBillingsDraft = (
    request: BillingsPlanEntryTaxiDriverDraftRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsPlanEntryTaxiDriverDraftResponse> => {
    const url = `/billings/plan-entry/${request.planEntryId}/taxi-driver/draft`;
    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getOrderForwardTaxiTaxiBillingsDraft = (
    request: BillingsOrderForwardTaxiTaxiDraftRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardTaxiTaxiDraftResponse> => {
    const url = `/billings/orders-forwarding/${request.forwardingId}/taxi-taxi/draft`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getTaxiTaxiBillingsDetails = (
    request: BillingsTaxiTaxiDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsTaxiTaxiDetailsResponse> => {
    const url = `/billings/${request.billingUuid}/taxi-taxi`;
    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const updateTaxiTaxiStatusBillings = (
    request: BillingsTaxiTaxiUpdateStatusRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsTaxiTaxiUpdateStatusResponse> => {
    const url = `/billings/${request.billingUuid}/taxi-taxi/status`;

    const body = billingsTaxiTaxiUpdateStatusRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const recalculateOrderForwardTaxiTaxiBillings = (
    request: BillingsOrderForwardTaxiTaxiRecalculateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderForwardTaxiTaxiRecalculateResponse> => {
    const url = `/billings/orders-forwarding/${request.orderForwardingUuid}/taxi-taxi/recalculate`;

    const body =
      billingsOrderForwardTaxiTaxiRecalculateRequestFactory.create(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const addOrderTaxiRailyBillings = (
    request: BillingsOrderTaxiRailyAddRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderTaxiRailyAddResponse> => {
    const url = `/billings/orders/${request.orderId}/taxi-raily`;

    const body: BillingsOrderTaxiRailyAddRequestBody =
      billingsOrderTaxiRailyAddRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const editTaxiTaxiBillings = (
    request: BillingsTaxiTaxiEditRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsTaxiTaxiEditResponse> => {
    const url = `/billings/${request.billingUuid}/taxi-taxi`;

    const body = billingsTaxiTaxiEditRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  const recalculateOrderTaxiRailyBillings = (
    request: BillingsOrderTaxiRailyRecalculateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderTaxiRailyRecalculateResponse> => {
    const url = `/billings/orders/${request.orderId}/taxi-raily/recalculate`;

    const body: BillingsOrderTaxiRailyRecalculateRequestBody =
      billingsOrderTaxiRailyRecalculateRequestFactory.createBody(request);

    return railyApiService().post({
      url,
      abortSignal,
      body,
    });
  };

  const getTaxiDriverBillingsDetails = (
    request: BillingsTaxiDriverDetailsRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsTaxiDriverDetailsResponse> => {
    const url = `/billings/${request.billingUuid}/taxi-driver`;
    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const getOrderTaxiRailyBillingsDraft = (
    request: BillingsOrderTaxiRailyDraftRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsOrderTaxiRailyDraftResponse> => {
    const url = `/billings/orders/${request.orderId}/taxi-raily/draft`;

    return railyApiService().get({
      url,
      abortSignal,
    });
  };

  const updateTaxiDriverBillings = (
    request: BillingsTaxiDriverUpdateRequest,
    abortSignal: AbortSignal,
  ): Promise<BillingsTaxiDriverUpdateResponse> => {
    const url = `/billings/${request.billingUuid}/taxi-driver`;

    const body = billingsTaxiDriverUpdateRequestFactory.createBody(request);

    return railyApiService().put({
      url,
      abortSignal,
      body,
    });
  };

  return {
    getOrderForwardRelatedCargoTaxiBillings,
    getOrderForwardRelatedTaxiDriverBillings,
    getOrderForwardRelatedTaxiTaxiBillings,
    getPlanEntryRelatedCargoTaxiBillings,
    getPlanEntryRelatedTaxiTaxiBillings,
    getOrderRelatedTaxiDriverBillings,
    getOrderRelatedTaxiTaxiBillings,
    getOrderBillingsAddresses,
    getCargoTaxiBillingsDetails,
    updateCargoTaxiBillings,
    getOrderCargoTaxiBillingsDraft,
    recalculateOrderCargoTaxiBillings,
    createOrderCargoTaxiBillings,
    updateCargoTaxiBillingsStatus,
    getOrderRailyTaxiBillingsDraft,
    recalculateOrderRailyTaxiBillings,
    createOrderRailyTaxiBillings,
    updateBulkStatusCargoTaxiBillings,
    getOrderRelatedTaxiRailyBillings,
    getOrderRelatedCargoRailyBillings,
    addOrderCargoRailyBillings,
    recalculateOrderCargoRailyBillings,
    getOrderCargoRailyBillingsDraft,
    getOrderRelatedRailyTaxiBillings,
    getOrderForwardBillingsDownload,
    getOrderForwardBillingsList,
    addPlanEntryTaxiDriverBillings,
    recalculatePlanEntryTaxiDriverBillings,
    getPlanEntryTaxiDriverBillingsDraft,
    getTaxiTaxiBillingsDetails,
    updateTaxiTaxiStatusBillings,
    addOrderForwardTaxiTaxiBillings,
    getOrderForwardTaxiTaxiBillingsDraft,
    recalculateOrderForwardTaxiTaxiBillings,
    editTaxiTaxiBillings,
    getTaxiDriverBillingsDetails,
    updateTaxiDriverBillings,
    addOrderTaxiRailyBillings,
    recalculateOrderTaxiRailyBillings,
    getOrderTaxiRailyBillingsDraft,
  };
};

export default billingsApiService;
